import {useEffect, useState} from "react";

export const TanValidity = ({status, busy}) => {
    const [now, setNow] = useState(Date.now);
    const expiresAt = Date.parse(status?.expiresAt);
    useEffect(() => {
        setNow(Date.now());
        if (!Number.isFinite(expiresAt)) return;
        const timer = setTimeout(() => setNow(Date.now()), Math.max(0, expiresAt - Date.now()));
        return () => clearTimeout(timer);
    }, [expiresAt]);

    if (!status || !Number.isFinite(expiresAt)) return null;
    return <p role="status">{(status.expired || now >= expiresAt)
        ? (busy ? "Ihr Code ist abgelaufen. Ein neuer Code wird gesendet." : "Der Code ist abgelaufen.")
        : `Code gültig bis ${new Date(expiresAt).toLocaleTimeString("de-AT", {hour: "2-digit", minute: "2-digit"})}.`}</p>;
};
